import React from 'react';
import {
  Box, Container, Typography,
} from '@mui/material';
import {
  InfiniteScroll,
  Fab,
  ChipOption,
  CountryOption,
  Option,
} from '@marageti/z4-lib';
import { TripRequest } from '@marageti/z4-sdk/lib/travel';
import { ApiError } from '@marageti/z4-sdk/lib/tracking';
import { LoadingButton } from '@mui/lab';
import IncomingFilters from './incoming-filters';
import IncomingRequestCard from '../../../components/list-cards/trip-request-cards/incoming';

type TripRequestIncomingViewProps = {
  error?: ApiError;
  getNextAvailable: () => void;
  hasMoreItems: boolean;
  isLoading: boolean;
  isSubmitting: boolean;
  items?: TripRequest[];
  loadMore: () => void;
  totalHits: string;
  destinationOptions: CountryOption[];
  isLoadingDestinations: boolean;
  onDestinationChange: (event: React.SyntheticEvent, countries: CountryOption[]) => void;
  selectedDestinations: CountryOption[];
  onSortChange: (v: string) => void;
  sortBy: string;
  sortByOptions: Option[];
  onTagChange: (selectedTags: string) => void;
  selectedTag: string;
  tagOptions: ChipOption[];
  selectedStatusChips: string[];
  onStatusChipChange: (selectedChips: string[]) => void;
};

const TripRequestsIncomingView = ({
  error = undefined,
  getNextAvailable,
  hasMoreItems,
  isLoading,
  isSubmitting,
  items = undefined,
  loadMore,
  totalHits,
  // Destination Props
  destinationOptions,
  isLoadingDestinations,
  onDestinationChange,
  selectedDestinations,
  // Sort Props
  onSortChange,
  sortBy,
  sortByOptions,
  // Tag Props
  onTagChange,
  selectedTag,
  tagOptions,
  selectedStatusChips,
  onStatusChipChange,
}: TripRequestIncomingViewProps) => (
  <Container maxWidth="xl">
    <Box pt={6} pb={12}>
      <Typography variant="h2" component="h1" mb={2}>
        Incoming
      </Typography>
      <IncomingFilters
        destinationOptions={destinationOptions}
        isLoadingDestinations={isLoadingDestinations}
        onDestinationChange={onDestinationChange}
        onSortChange={onSortChange}
        onTagChange={onTagChange}
        selectedDestinations={selectedDestinations}
        selectedTag={selectedTag}
        sortBy={sortBy}
        sortByOptions={sortByOptions}
        tagOptions={tagOptions}
        selectedStatusChips={selectedStatusChips}
        onStatusChipChange={onStatusChipChange}
      />
      <Typography
        variant="bodyBold"
        sx={{ mb: 1.5 }}
      >
        {`${totalHits} Results`}
      </Typography>
      <InfiniteScroll
        error={error}
        hasMoreItems={hasMoreItems}
        isLoading={isLoading}
        loadMoreItems={loadMore}
        noItemsText="No trip requests found."
        stackProps={{ spacing: 1 }}
      >
        {items?.flatMap((item: TripRequest) => (
          <IncomingRequestCard
            key={item.id}
            tripRequest={item}
          />
        ))}
      </InfiniteScroll>
    </Box>
    <Fab>
      <LoadingButton
        loading={isSubmitting}
        onClick={getNextAvailable}
        sx={{ width: 'fit-content' }}
        variant="contained"
      >
        Get Next Available
      </LoadingButton>
    </Fab>
  </Container>
);

export default TripRequestsIncomingView;
